import { useState, useEffect } from "react";
import "./ResponseContentShort.css";
import { Question, Response } from "effno-core";
import { useSelector } from "react-redux";
import { selectUIStates } from "../../redux/features/appData";
import { ResponseNavigate } from "./ResponseNavigate";
import { ShortResponse } from "../config/responseSettings";
import config from "environment";
import { ShortSettings } from "../config/questionSettings";
import { ResponseErrors } from "./responseErrors";
import { NEXT_BUTTON } from "./ResponseContent";
import { ChevronDown, ChevronLeft, ChevronRight, ChevronUp, TriangleAlert } from "lucide-react";

const debugMode = config.debugMode;

type ResponseContentShortProps = {
    question: Question;
    responseValues: string;
    isPreview: boolean;
    isMobileLayout: boolean;
    isLastQuestion: boolean;
    commentMode: boolean;
    onNext?: () => void;
    onPrev?: () => void;
    onSubmit: (responseValues: string) => void;
}

export const ResponseContentShort = ({
    question,
    responseValues,
    isPreview,
    isMobileLayout,
    isLastQuestion,
    commentMode,
    onNext,
    onPrev,
    onSubmit
} : ResponseContentShortProps) => {

    // const uiStates = useSelector(selectUIStates);

    const [title, setTitle] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [text, setText] = useState<string>("");
    const [error, setError] = useState<string>("");

    useEffect(() => {
        setTitle(question.title);
        setDescription(question.description);
        setText(JSON.parse(responseValues).text || "");
        setError(ResponseErrors.none);
    }, [question, responseValues])

    const handleNext = () => {
        if (isPreview && onNext) {
            onNext();
        } else {
            handleSubmit();
        }
    }
   
    const handleSubmit = () => {
        if (question.required && text.trim() === "") {
            setError(ResponseErrors.required);
            return;
        }

        const settings = JSON.parse(question.settings) as ShortSettings;

        if (settings.maxCharsOn && text.length > settings.maxChars) {
            setError(ResponseErrors.maxChars);
            return;
        }

        const newResponseValues: string = JSON.stringify({
            text
        } as ShortResponse);

        onSubmit(newResponseValues);
    }

    const handleKeyDown = (e: any) => {
        
        if (e.key === "Enter") {
            handleSubmit();
            return;
        }

        const settings = JSON.parse(question.settings) as ShortSettings;

        console.log("[ResponseContentShort] settings: ", settings);
        
        if (settings.maxCharsOn) {
            if (text.length >= settings.maxChars) {
                if (e.key === "Backspace") {
                    setError((text.length - 1 >= settings.maxChars) ? ResponseErrors.maxChars : "");
                    return;
                } else {
                    setError(ResponseErrors.maxChars);
                    e.preventDefault();
                    return;
                }
            }
        }

        setError(ResponseErrors.none);
    
    }

    const handlePaste = (e: any) => {
        const paste = e.clipboardData.getData('text');
        setText(paste);

        const settings = JSON.parse(question.settings) as ShortSettings;
        
        if (settings.maxCharsOn) {
            if (paste.length >= settings.maxChars) {
                setError(ResponseErrors.maxChars);
                return;
            }
        }

        setError(ResponseErrors.none);
    }

    const handleChange = (e: any) => {
        setText(e.target.value);
    }

    const requirementsMet = !question.required || (text.trim() !== "");
    
    // console.log("[ResponseContentShort] question: ", question);
    // console.log("[ResponseContentShort] values: ", responseValues);
    // console.log("[ResponseContentShort] text: ", text);
    console.log("[ResponseContentShort] isPreview: ", isPreview);


    return (
         <div className="form-content-body">

            {/* {debugMode && question &&
                <div className="response-content-question-id">
                    {question.id}
                </div>
            } */}
                        
            
            <div 
                className="response-content-title"
                data-testid={"response-content-title:" + title}
            >
                {title}
            </div>
            
            <div className="response-content-description">
               {description}
            </div>   

            <div style={{marginTop: "24px"}} className="response-content-text">
                <input 
                    type="text"
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    onPaste={handlePaste}
                    value={text}
                    placeholder="Your answer here.."
                    data-testid="response-content-value"
                    autoFocus={true}
                />
            </div> 
               
            <div 
                className="response-content-error"
                style={!error ? {backgroundColor: "transparent"} : {}}
                data-testid="response-content-error"
            >
                {error && <TriangleAlert size={16}/>}{error}
            </div>

            <ResponseNavigate 
                isMobileLayout={isMobileLayout}
                isLastQuestion={isLastQuestion}
                commentMode={commentMode}
                allowEnter={true}
                onSubmit={handleSubmit}
                onNext={handleNext}
                onPrev={onPrev}
            />

            {/* {!isMobileLayout &&
                <>
                    <div className="response-content-submit">
                        <button
                            className="response-content-button-submit"
                            onClick={handleSubmit}
                            data-testid="response-content-submit"
                        >
                            {onNext ? NEXT_BUTTON : "Submit"}
                        </button>
                    </div>

                    <ResponseNavigate 
                        isMobileLayout={isMobileLayout}
                        onNext={handleNext}
                        onPrev={onPrev}
                    />
                </>
            }

            {isMobileLayout &&
                <div className="response-content-mobile-footer-wrapper">
                    <div className="response-content-mobile-footer">
                        {onPrev &&
                            <div 
                                className="response-navigate-button"
                                data-testid="response-navigate-prev"
                                onClick={onPrev}
                            >
                                    <ChevronLeft 
                                        size={20}
                                        color="var(--ftButtonTextColor)"
                                    />
                                
                            </div>
                        }

                        <button
                            className="response-content-button-submit-mobile"
                            onClick={handleSubmit}
                            data-testid="response-content-submit"
                        >
                            {onNext ? NEXT_BUTTON : "Submit"}
                        </button>

                        {onNext &&
                            <div 
                                className="response-navigate-button"
                                data-testid="response-navigate-next"
                                onClick={onNext}
                            >
                                    <ChevronRight 
                                        size={20}
                                        color="var(--ftButtonTextColor)"
                                    />                
                                
                            </div>
                        }
                    </div>

                    <div 
                        className="response-content-mobile-footer-branding"
                        onClick={() => window.open("https://effno.co", "_blank")}
                    >
                        Powered by&nbsp;<b>effno</b>
                    </div>
                </div>
            } */}

        </div>
    )
}